import React, { Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Toggle from '../../Elements/Toggle';

import MenuVariaveis from '../../MenuVariaveis';

export default (props) => {
  const {
    answerHandlerOpen,
    toggleAnswerHandler,
    doUpdateItem,
    item,
    user,
  } = props;

  const { i18n } = useTranslation();

  const [senderName, setSenderName] = useState(item.senderName || '');
  const [destinationContact, setDestinationContact] = useState(
    item.destinationContact || ''
  );
  const [destinationCCContact, setDestinationCCContact] = useState(
    item.destinationCCContact || ''
  );
  const [subject, setSubject] = useState(item.subject || '');
  const [message, setMessage] = useState(item.message || '');

  const [html, setHtml] = useState(
    item.html === undefined || null ? false : item.html
  );

  useEffect(() => {
    setSenderName(item.senderName || '');
    setDestinationContact(item.destinationContact || '');
    setDestinationCCContact(item.destinationCCContact || '');
    setSubject(item.subject || '');
    setMessage(item.message || '');
  }, [item]);

  const onInputChanged = (value, state, name) => {
    state(value);
    const payload = { html };
    payload[name] = value;
    doUpdateItem(payload);
  };

  const handleSelectVariavel = (name, value, variavel, setState) => {
    const newValue = `${value} {${variavel}}`;

    setState(newValue);
    doUpdateItem({ [name]: newValue });
  };

  const handleSetHtml = () => {
    setHtml(!html);

    handleSendHtmlOnSelect();
  };

  const handleSendHtmlOnSelect = () => {
    const payload = { html: !html };
    payload['message'] = message;

    doUpdateItem(payload);
  };

  return (
    <Fragment>
      <p className="pointer handler-title" onClick={toggleAnswerHandler}>
        {i18n.t('Configurações de envio')}{' '}
        <img
          alt=""
          className={
            'seta-expander ' + (!answerHandlerOpen ? 'arrow-rotation' : '')
          }
          src="/assets/images/icons/seta_close.svg"
        />
      </p>

      {/* NOME REMETENTE */}
      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel(
            'senderName',
            senderName,
            variavel,
            setSenderName
          )
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-senderName`}
        isTooltip
        hidden={!answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>
            {i18n.t('Nome do remetente ')} <small>({i18n.t('opcional')})</small>
          </label>
          <input
            type="text"
            placeholder="Ex: Boteria"
            id="senderName"
            className="form-control mt-1"
            value={senderName}
            onChange={(e) =>
              onInputChanged(e.target.value, setSenderName, 'senderName')
            }
          />
        </div>
      </MenuVariaveis>

      {/* CONTADO DE DESTINO */}
      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel(
            'destinationContact',
            destinationContact,
            variavel,
            setDestinationContact
          )
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-destinationContact`}
        isTooltip
        hidden={!answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Contato de destino')}</label>
          <input
            type="text"
            placeholder="contato@exemplo.com.br"
            id="destinationContact"
            className="form-control mt-1"
            value={destinationContact}
            onChange={(e) =>
              onInputChanged(
                e.target.value,
                setDestinationContact,
                'destinationContact'
              )
            }
          />
        </div>
      </MenuVariaveis>

      {/* CC CONTADO DE DESTINO */}
      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel(
            'destinationCCContact',
            destinationCCContact,
            variavel,
            setDestinationCCContact
          )
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-destinationCCContact`}
        isTooltip
        hidden={!answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('CC Contato de destino')}</label>
          <input
            type="text"
            placeholder="contato2@exemplo.com.br"
            className="form-control mt-1"
            id="destinationCCContact"
            value={destinationCCContact}
            onChange={(e) =>
              onInputChanged(
                e.target.value,
                setDestinationCCContact,
                'destinationCCContact'
              )
            }
          />
        </div>
      </MenuVariaveis>

      {/* ASSUNTO */}
      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel('subject', subject, variavel, setSubject)
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-subject`}
        isTooltip
        hidden={!answerHandlerOpen}
      >
        <div className="common-form-group">
          <label>{i18n.t('Assunto')}</label>
          <input
            type="text"
            placeholder={i18n.t('Assunto')}
            className="form-control mt-1"
            value={subject}
            id="subject"
            onChange={(e) =>
              onInputChanged(e.target.value, setSubject, 'subject')
            }
          />
        </div>
      </MenuVariaveis>

      {/* MENSAGEM */}
      <MenuVariaveis
        onSelect={(variavel) =>
          handleSelectVariavel('message', message, variavel, setMessage)
        }
        buttonRight="27px"
        buttonBottom="25px"
        id={`bloco-${item._id}-configuracao-message`}
        isTooltip
        hidden={!answerHandlerOpen}
      >
        <div className="common-form-group">
          <div className="email-label-container">
            <label>{i18n.t('Mensagem')}</label>
            <Toggle
              disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
              disabled={false}
              checked={html}
              label="HTML"
              onChange={handleSetHtml}
            />
          </div>
          <textarea
            placeholder={i18n.t(
              'Digite aqui sua mensagem personalizada de Email.'
            )}
            className="form-control mt-1"
            id="message-email"
            value={message}
            onChange={(e) =>
              onInputChanged(e.target.value, setMessage, 'message')
            }
          />
        </div>
      </MenuVariaveis>
    </Fragment>
  );
};
